import {
  Hotel,
  PlaneIcon,
  CarFront,
  FerrisWheel,
  CableCar,
  CalendarCheck2,
  Car,
  Home,
  Plane,
  Ship,
  TrainFront,
  Utensils,
  Cigarette,
  CigaretteOff,
} from "lucide-react";
import { GoPersonFill } from "react-icons/go";
import { MdBedroomParent } from "react-icons/md";
import { DynamicIcon } from "lucide-react/dynamic";
export class Config {
  constructor(translate = null) {
    this.translate = translate;
  }

  serviceOptions() {
    return [
      { value: "", label: this.translate("all") },
      { value: "hotel", label: this.translate("hotel") },
      { value: "flight", label: this.translate("flight") },
      { value: "activity", label: this.translate("activity") },
      { value: "transfer", label: this.translate("transfer") },
    ];
  }

  paymentOptions() {
    return [
      { value: "", label: this.translate("all") },
      { value: "paid", label: this.translate("paid") },
      { value: "unpaid", label: this.translate("unpaid") },
      { value: "refund", label: this.translate("refund") },
    ];
  }

  datesOptions() {
    return [
      { value: "created_at", label: this.translate("creation_date") },
      { value: "checkin", label: this.translate("checkin") },
      { value: "checkout", label: this.translate("checkout") },
    ];
  }
  userStatusOptions() {
    return [
      { value: "", label: this.translate("all") },
      { value: "enabled", label: this.translate("enabled") },
      { value: "disabled", label: this.translate("disabled") },
    ];
  }
  statusOptions() {
    return [
      { value: "", label: this.translate("all") },
      { value: "confirmed", label: this.translate("confirmed") },
      { value: "cancelled", label: this.translate("cancelled") },
      { value: "inprocess", label: this.translate("inprocess") },
    ];
  }
  productStatusOptions() {
    return [
      { value: "", label: this.translate("all") },
      { value: "draft", label: this.translate("draft") },
      { value: "pending", label: this.translate("pending") },
      { value: "accepted", label: this.translate("accepted") },
      { value: "rejected", label: this.translate("rejected") },
    ];
  }

    ticketStatusOptions() {
    return [     
      { value: "new", label: this.translate("new") },
      { value: "in_progress", label: this.translate("inprogress") },
      { value: "waiting", label: this.translate("waiting") },
      { value: "resolved", label: this.translate("resolved") },
      { value: "closed", label: this.translate("closed") }
    ];
  }
      ticketServiceOptions() {
    return [     
      { value: 1, label: this.translate("sales") },
      { value: 2, label: this.translate("media") },
      { value: 3, label: this.translate("support") }
    ];
  }
  
    ticketPriorityOptions() {
    return [
      { value: "low", label: this.translate("low") },
      { value: "medium", label: this.translate("medium") },
      { value: "high", label: this.translate("high") },
      { value: "urgent", label: this.translate("urgent") }
    ];
  }

  serviceIcon(service) {
    const icons = {
      hotel: <Hotel size={17} />,
      transfer: <CarFront size={17} />,
      flight: <PlaneIcon size={17} />,
      activity: <FerrisWheel size={17} />,
      Hosting: <Home size={17} />,
      package: <Ship size={17} />,
      car: <Car size={17} />,
      restaurant: <Utensils size={17} />,
      events: <CalendarCheck2 size={17} />,
    };
    return icons[service];
  }

  productIcons(service) {
    const productIcons = {
      Hotel: <Hotel size={25} strokeWidth={1.2} />,
      Flight: <Plane size={25} strokeWidth={1.2} />,
      Transport: <TrainFront size={25} strokeWidth={1.2} />,
      Activity: <CableCar size={25} strokeWidth={1.2} />,
      Hosting: <Home size={25} strokeWidth={1.2} />,
      Package: <Ship size={25} strokeWidth={1.2} />,
      Car: <Car size={25} strokeWidth={1.2} />,
      Restaurant: <Utensils size={25} strokeWidth={1.2} />,
      Events: <CalendarCheck2 size={25} strokeWidth={1.2} />,
    };

    return productIcons[service];
  }

  icon(name, size = 20, strokeWidth = 1.2) {
    return <DynamicIcon name={name} size={size} strokeWidth={strokeWidth} />;
  }

  priceType(value) {
    const a = {
      per_room: this.translate("ho_act_frais_parRoom"),
      per_person: this.translate("ho_act_frais_parPerson"),
    };
    return a[value];
  }
  priceTypeOptions() {
    return [
      { value: "per_room", label: this.translate("ho_act_frais_parRoom") },
      { value: "per_person", label: this.translate("ho_act_frais_parPerson") },
    ];
  }

  priceTypeIcon(value) {
    const a = {
      per_room: (
        <MdBedroomParent
          style={{
            width: "80px",
            height: "80px",
            color: "lightblue",
          }}
        />
      ),
      per_person: (
        <GoPersonFill
          style={{
            width: "80px",
            height: "80px",
            color: "lightblue",
          }}
        />
      ),
    };
    return a[value];
  }
  stopSales(value) {
    const status = [
      this.translate("tarif_active"),
      this.translate("tarif_inactive"),
    ];
    return status[value];
  }
  stopSalesColor(value) {
    const status = ["#4caf50", "#d32f2f"];
    return status[value];
  }

  statusColor(value) {
    const status = {
      enabled: "green",
      disabled: "red",
    };
    return status[value];
  }

  statusActionColor(value) {
    const status = {
      enabled: "red",
      disabled: "green",
    };
    return status[value];
  }

  userStatusAction(value) {
    const status = {
      enabled: this.translate("disabled"),
      disabled: this.translate("enabled"),
    };
    return status[value];
  }
  userStatusColor(value) {
    const status = {
      enabled: "#4caf50",
      disabled: "#d32f2f",
    };
    return status[value];
  }
  userBorderColor(value) {
    const status = {
      enabled: "border-success",
      disabled: "border-warning",
    };
    return status[value];
  }

  typePromotionOptions() {
    return [
      { value: "percentage", label: this.translate("percentage") },
      { value: "amount", label: this.translate("amount") },
    ];
  }

  smoking(status) {
    const icons = [
      <span className="text-red">
        <CigaretteOff className="mx-3" strokeWidth={1.4} /> No permitted
      </span>,
      <span className="text-green">
        <Cigarette className="mx-3" strokeWidth={1.4} /> permitted ,
      </span>,
    ];

    return icons[status];
  }
}
